import { Link, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import LeadsPanel from "@/components/LeadsPanel";
import MsaDownloadButton from "@/components/MsaDownloadButton";
import VendorStatementButton from "@/components/VendorStatementButton";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_sriman-enterprise/artifacts/ng31c679_image.png";

export default function CrmDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/crm/login", { replace: true });
  };

  return (
    <main data-testid="crm-dashboard-page" className="min-h-screen bg-[#040812] pt-24 pb-24">
      {/* Header */}
      <div className="border-b border-white/5 bg-[#040812]/95 backdrop-blur-xl fixed top-0 inset-x-0 z-40">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <span className="h-9 w-9">
              <img src={LOGO_URL} alt="Sriman Solutions" className="h-full w-full object-contain" />
            </span>
            <div className="flex flex-col leading-none">
              <span className="font-display text-white text-sm tracking-tight">Sriman Solutions</span>
              <span className="font-mono text-[9px] text-red-500 tracking-[0.28em] uppercase mt-1">
                Partner CRM
              </span>
            </div>
          </Link>
          <div className="flex items-center gap-3">
            <VendorStatementButton />
            <MsaDownloadButton />
            <Link
              to="/crm/profile"
              data-testid="crm-profile-link"
              className="hidden md:inline-flex items-center gap-2 border border-white/15 hover:border-red-500 text-white text-xs font-medium px-4 py-2 rounded-sm transition-colors"
            >
              Profile
            </Link>
            <span className="hidden md:block text-xs text-slate-500 font-mono">
              {user?.name} · {user?.email}
            </span>
            <button
              onClick={handleLogout}
              data-testid="crm-logout-button"
              className="inline-flex items-center gap-2 border border-white/15 hover:border-red-500 text-white text-xs font-medium px-4 py-2 rounded-sm transition-colors"
            >
              <LogOut size={14} /> Sign out
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-6">
        <LeadsPanel variant="vendor" vendors={[]} />
      </div>
    </main>
  );
}
